import * as React from 'react';
import { DocumentRenderMode, DocumentView } from "../../document-view";
import { DocumentContainer } from '../style';
/**
 *
 * @param props ICarouselItemTypeProps
 * @returns DocumentContainerView - component
 */
export const DocumentContainerView = ({ carouselViewProps }) => {
    const { file, index, pdfRenderMode = DocumentRenderMode.SVG } = carouselViewProps;
    return (React.createElement(DocumentContainer, { id: `document-container-${index}` },
        React.createElement(DocumentView, { id: `document-${index}`, url: file.url, type: file.fileType, renderMode: pdfRenderMode })));
};
//# sourceMappingURL=DocumentContainerView.js.map